import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { PageWrapper } from '../../components/PageWrapper';
import { Organization } from '../../services/organization/types';
import { ManageInstallers } from './ManageInstallers';

export const ManageInstallersPage: React.FC = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const organization = (location.state as { organization?: Organization })?.organization;

    return (
        <PageWrapper title={t('MANAGE_INSTALLERS_PAGE.TITLE')}>
            <ManageInstallers organization={organization} />
        </PageWrapper>
    );
};
